/**
 * Represents a service for showing confirm inputs.
 */
export const ConfirmService = Symbol('ConfirmService');
